import type { Framework } from '@toeverything/infra';

import { GlobalDialogService } from '../dialogs';
import { UrlService } from '../url';
import { HelpActionsService } from './services/help-actions';

export { HelpActionsService } from './services/help-actions';
export {
  resolveStatusUrl,
  sanitizeFeedbackPrefill,
} from './services/help-actions';

export function configureHelpActionsModule(framework: Framework) {
  framework.service(
    HelpActionsService,
    services =>
      new HelpActionsService(
        services.get(GlobalDialogService),
        services.get(UrlService)
      )
  );
}
